import React from 'react';
import {connect} from "react-redux";
import Select from "react-select";
import * as utils from "../../../utils/commodityGroup";
import l10n from "../../../l10n/localization";
import {Button} from "react-materialize";
import * as creationActions from "../../../actions/creation";
import CommodityGroupForm from "../CommodityGroupForm";

class SelectCommodityGroups extends React.Component {
    constructor(props) {
        super(props);
        this.state = {...props.formData};
    }

    onChange(value) {
        this.props.onChange(value);
    }

    render() {
        return (
            <div className="form-group field">
                <Button type="button" floating onClick={() => this.props.schema.openDrawer(CommodityGroupForm, null, creationActions.destroyingnewlyCreatedCommodityGroup())} icon="add" className="add-button btn-md ml5"/>

                <label className="control-label" htmlFor="root_company">
                    {l10n.common.commodityGroup}
                </label>

                <Select
                    backspaceRemoves={false}
                    className="form-control"
                    name="root_company"
                    value={this.props.formData}
                    options={utils.commodityGroupToSelect(this.props.commodityGroups)}
                    isLoading={this.props.loading}
                    clearable={false}
                    onChange={this.onChange.bind(this)}
                    simpleValue
                    valueComponent={(props) => {
                        return (
                            <div className="Select-value" title={props.value.title}>
                                <span className="Select-value-label">
                                    {props.children}
                                    <div className="pull-right mr25 input-button-wrapper">
                                        <i>
                                            <Button type="button" floating onClick={() => this.props.schema.openDrawer(CommodityGroupForm, {item: props.value.item}, creationActions.destroyingnewlyCreatedCommodityGroup())} icon="edit" className="edit-button small"/>
                                        </i>
                                    </div>
                                </span>
                            </div>
                        )
                    }}
                />
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        commodityGroups: state.commodityGroup.commodityGroups,
        loading: state.commodityGroup.loading
    });
})(SelectCommodityGroups);


// WEBPACK FOOTER //
// ./src/components/forms/fields/SelectCommodityGroups.js